import EnumService from '../EnumService'

export default class TipoContaContabilEnumService extends EnumService{
    constructor(){
        super('enumTipoContaContabil');
    }
}
